import * as React from "react";

import { AjaxManager } from "@impero-com/common/utils/ajax";
import { OrgCookie } from "@impero-com/common/utils/orgCookie";

import type { UserProfile } from "api/generated/model";
import { AvailableActions } from "api/generated/model";

import { Controls } from "..";

interface AllControlsProps {
    ajaxManager: AjaxManager;
    orgCookie: OrgCookie;
    orgProfileCookie: UserProfile | null;
    availableActions: AvailableActions;
}

class AllControls extends React.PureComponent<AllControlsProps> {
    render = () => {
        const { ajaxManager, orgCookie, orgProfileCookie, availableActions } =
            this.props;

        return (
            <Controls
                schedulingTypeOrAll="All"
                ajaxManager={ajaxManager}
                availableActions={availableActions}
                orgCookie={orgCookie}
                orgProfileCookie={orgProfileCookie}
            />
        );
    };
}

export { type AllControlsProps, AllControls };
